import moment from "moment";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import util from "./util";
import { getDashboards } from "../../store/middleware";
import { endLoading, initLoading } from "../../store/slices/generics.slice";

import { Cards } from "./styles";

function CardsAnalytics() {
  const dispatch = useDispatch();
  const { dashboards } = useSelector((state) => state.companyManagerReducer);

  const today = new Date();
  const months = util.getMonths();
  const years = util.getYearsByYearInterval(5);

  const [shouldShowClassesFilter, setShouldShowClassesFilter] = useState(false);
  const [shouldShowTeachersFilter, setShouldShowTeachersFilter] = useState(false);
  const [teacherFilterCriteria, setTeacherFilterCriteria] = useState({ id: 1, nameEnglish: "Teacher" });
  const [classesFilterCriteria, setClassesFilterCriteria] = useState({
    year: today.getUTCFullYear(),
    month: moment(today).format("MMMM"),
  });

  const getData = async (filter) => {
    dispatch(initLoading());
    await dispatch(getDashboards(filter));
    dispatch(endLoading());
  };

  const showClassesFilter = () => setShouldShowClassesFilter(true);
  const showTeachersFilter = () => setShouldShowTeachersFilter(true);

  const handleTeacherFilterCriteria = (e) => {
    const { id, nameEnglish } = JSON.parse(e.target.name);
    setTeacherFilterCriteria({ id: id, nameEnglish: nameEnglish });
  };

  const applyTeacherFilter = () => {
    if (teacherFilterCriteria.id > 0) {
      getData(`ratingCriteriaId=${teacherFilterCriteria.id}`);
      setShouldShowTeachersFilter(false);
    }
  };

  const clearTeacherFilterCriteria = () => {
    setTeacherFilterCriteria({ id: 1, nameEnglish: "Teacher" });
    setShouldShowTeachersFilter(false);
    getData();
  };

  const handleChangeClassesFilterCriteria = (e) => {
    const { name, value } = e.target;
    if (name === "month") setClassesFilterCriteria((state) => ({ ...state, month: value }));
    if (name === "year") setClassesFilterCriteria((state) => ({ ...state, year: value }));
  };

  const applyClassesFilter = () => {
    const month = parseInt(classesFilterCriteria.month) + 1;
    const filter = `year=${classesFilterCriteria.year}&month=${month}`;

    getData(filter);
    setShouldShowClassesFilter(false);
  };

  const clearClassesFilterCriteria = () => {
    setClassesFilterCriteria({ year: today.getUTCFullYear(), month: today.getUTCMonth() });
    setShouldShowClassesFilter(false);
    getData();
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Cards>
        <div className="container">
          <div style={{ marginBottom: 40 }} />

          <div className="box">
            {shouldShowTeachersFilter ? (
              <div className="boxAnalytics">
                <h3 className="text-center">Filter</h3>
                <div className="container space-around">
                  <div className="criterias">
                    <ul>
                      {dashboards?.teachers?.ratingCriterias?.map((item) => {
                        return (
                          item.active && (
                            <li key={item.id}>
                              <button
                                type="button"
                                name={JSON.stringify(item)}
                                onClick={handleTeacherFilterCriteria}
                                className={item.id == teacherFilterCriteria.id ? "auto active" : "auto"}
                              >
                                {item.nameEnglish}
                              </button>
                            </li>
                          )
                        );
                      })}
                    </ul>
                  </div>
                  <div className="filter buttons">
                    <button onClick={clearTeacherFilterCriteria} type="button">
                      Cancel
                    </button>
                    <button onClick={applyTeacherFilter} type="button" className="primary">
                      Filter
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="boxAnalytics">
                <div className="items">
                  <div className="rating">
                    <h3>Teachers</h3>
                    <p>Overall average rating</p>
                    <div className="stars startList">
                      <span className="grades">{dashboards?.teachers?.averageRating[0]?.rating ?? 0}</span>
                      {/* <Rating
                        emptySymbol="fa fa-star-o fa-2x"
                        fullSymbol="fa fa-star fa-2x"
                        readonly
                        initialRating={Number(dashboards?.teachers?.averageRating[0]?.rating)}
                      /> */}
                    </div>
                  </div>
                  <div className="filter">
                    <button onClick={showTeachersFilter}>
                      <i className="fa fa-filter" aria-hidden="true"></i>Filter
                    </button>
                    <span>{teacherFilterCriteria.nameEnglish}</span>
                  </div>
                </div>

                <div className="items">
                  <div className="listBest">
                    <div>
                      <h4>Best rated teachers</h4>
                    </div>
                    {dashboards?.teachers?.highest?.map((high, i) => {
                      return (
                        <div key={i} className="startList">
                          {/* <Rating
                            emptySymbol="fa fa-star fa-2x"
                            fullSymbol="fa fa-star fa-2x"
                            readonly
                            fractions={2}
                            stop={1}
                          /> */}
                          <span className="grades">{high.rating}</span>
                          <h4>{high.teacher}</h4>
                        </div>
                      );
                    })}
                  </div>
                  <div className="listBest">
                    <div>
                      <h4>Lowest rated teachers</h4>
                    </div>
                    {dashboards?.teachers?.lowest?.map((item, i) => {
                      return (
                        <div key={i} className="startList">
                          {/* <Rating
                            emptySymbol="fa fa-star-o fa-2x"
                            fullSymbol="fa fa-star fa-2x"
                            readonly
                            fractions={2}
                            stop={1}
                          /> */}
                          <span className="grades">{item.rating}</span>
                          <h4>{item.teacher}</h4>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            {shouldShowClassesFilter ? (
              <div className="boxAnalytics">
                <h3 className="text-center">Filter</h3>
                <div className="container space-around">
                  <div className="criterias">
                    <select
                      name="month"
                      className="filter"
                      value={classesFilterCriteria.month}
                      onChange={handleChangeClassesFilterCriteria}
                      style={{ width: "150px", marginRight: "10px" }}
                    >
                      <option value="">Month</option>
                      {months.map((item) => {
                        return (
                          <option key={item} value={item}>
                            {moment().set({ month: item }).format("MMMM")}
                          </option>
                        );
                      })}
                    </select>

                    <select
                      name="year"
                      className="filter"
                      value={classesFilterCriteria.year}
                      onChange={handleChangeClassesFilterCriteria}
                    >
                      <option value="">Year</option>
                      {years.map((item) => {
                        return (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="filter buttons">
                    <button onClick={clearClassesFilterCriteria} type="button">
                      Cancel
                    </button>
                    <button onClick={applyClassesFilter} type="button" className="primary">
                      Filter
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="boxAnalytics">
                <div>
                  <div className="items">
                    <div className="rating">
                      <h3>Classes</h3>
                      <p>
                        {moment().set({ month: classesFilterCriteria.month }).format("MMMM")} /{" "}
                        {classesFilterCriteria.year}{" "}
                      </p>
                    </div>
                    <div className="filter">
                      <button onClick={showClassesFilter} type="button">
                        <i className="fa fa-filter" aria-hidden="true"></i>Filter
                      </button>
                    </div>
                  </div>

                  <div className="items">
                    <table>
                      <tbody>
                        <tr>
                          <td>Regular</td>
                          <td>{dashboards?.classes?.regular ?? 0}</td>
                        </tr>
                        <tr>
                          <td>Demo</td>
                          <td>{dashboards?.classes?.demo ?? 0}</td>
                        </tr>
                        <tr>
                          <td>Cancelled</td>
                          <td>{dashboards?.classes?.canceled ?? 0}</td>
                        </tr>
                        <tr>
                          <td>No show</td>
                          <td>{dashboards?.classes?.noShow ?? 0}</td>
                        </tr>
                        <tr>
                          <td>Cancelled by Lingo</td>
                          <td>{dashboards?.classes?.canceledByLingo ?? 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            <div className="boxAnalytics">
              <div className="items">
                <div className="rating">
                  <h3>New students</h3>
                  <p>{moment().format("MMMM")}</p>
                </div>
              </div>

              <div className="items">
                <table>
                  <tbody>
                    {dashboards?.newStudentsWithoutFlags?.length > 0 &&
                      dashboards?.newStudentsWithoutFlags?.map((item, index) => (
                        <tr key={index}>
                          <td>{item.nameEnglish}</td>
                          <td className="total">{item.studentPlans}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="boxCards">
            <div className="cards">
              <div className="items">
                <h4>Students</h4>
                <small>Total</small>
              </div>

              <div className="items">
                <span>{dashboards?.students?.studentsActive ?? 0}</span>
                <small>Active</small>
              </div>
              <div className="items">
                <span>{dashboards?.students?.studentsInactive ?? 0}</span>
                <small>Inactive</small>
              </div>
            </div>
            <div className="cards">
              <div className="items">
                <h4>Cancellations</h4>
                <small>{moment().format("MMMM")}</small>
              </div>

              <div className="items">
                <span>{dashboards?.cancellations ?? 0}</span>
              </div>
            </div>
            <div className="cards">
              <div className="items">
                <h4>Demo Class</h4>
                <small>Total</small>
              </div>

              <div className="items">
                <span>{dashboards?.demoClass?.classes ?? 0}</span>
                <small>classes</small>
              </div>
              <div className="items">
                <span>{dashboards?.demoClass?.converted ?? 0}</span>
                <small>converted</small>
              </div>
              <div className="items">
                <span>
                  <strong>
                    {dashboards?.demoClass?.classes > 0
                      ? Math.round((dashboards?.demoClass?.converted / dashboards?.demoClass?.classes) * 100)
                      : 0}
                    %
                  </strong>
                </span>
                <small>rate</small>
              </div>
            </div>
          </div>
        </div>
      </Cards>
    </div>
  );
}

export default CardsAnalytics;
